<main>
  <div class="new-release-page shadow">
    <h5>New Release</h5>
    <form class="form" [formGroup]="releaseCreateForm" (ngSubmit)="createRelease()">
      <h6>Release Details</h6>
      <div class="d-flex g-g">
        <div class="flex-fill errors-wrapper">
          <label for="name" class="form-label">Name</label>
          <input type="text" class="form-control" id="name"
                 [formControl]="releaseCreateForm.controls.name"
                 [class.invalid-input]="releaseCreateForm.controls.name.errors">
          @if (releaseCreateForm.controls.name.errors?.['required']) {
            <div class="input-error">
              Name is required
            </div>
          }
        </div>

        <div class="errors-wrapper">
          <label for="date" class="form-label">Date</label>
          <input type="date" class="form-control" id="date"
                 [formControl]="releaseCreateForm.controls.date"
                 [class.invalid-input]="releaseCreateForm.controls.date.errors">
          @if (releaseCreateForm.controls.date.errors?.['required']) {
            <div class="input-error">
              Date is required
            </div>
          }
        </div>
      </div>

      <div class="errors-wrapper">
        <label for="cn5gTagName" class="form-label">CN5G Tag Name</label>
        <input type="text" class="form-control" id="cn5gTagName"
               [formControl]="releaseCreateForm.controls.cn5gTagName"
               [class.invalid-input]="releaseCreateForm.controls.cn5gTagName.errors">
        @if (releaseCreateForm.controls.cn5gTagName.errors?.['required']) {
          <div class="input-error">
            Tag Name is required
          </div>
        }
      </div>

      <div class="errors-wrapper">
        <label for="flexRicTagName" class="form-label">FlexRIC Tag Name</label>
        <input type="text" class="form-control" id="flexRicTagName"
               [formControl]="releaseCreateForm.controls.flexRicTagName"
               [class.invalid-input]="releaseCreateForm.controls.flexRicTagName.errors">
        @if (releaseCreateForm.controls.flexRicTagName.errors?.['required']) {
          <div class="input-error">
            Tag Name is required
          </div>
        }
      </div>

      <div class="errors-wrapper">
        <label for="gnbTagName" class="form-label">gNB Tag Name</label>
        <input type="text" class="form-control" id="gnbTagName"
               [formControl]="releaseCreateForm.controls.gnbTagName"
               [class.invalid-input]="releaseCreateForm.controls.gnbTagName.errors">
        @if (releaseCreateForm.controls.gnbTagName.errors?.['required']) {
          <div class="input-error">
            Tag Name is required
          </div>
        }
      </div>

      <div class="errors-wrapper">
        <label for="orchestrationTagName" class="form-label">Orchestration Tag Name</label>
        <input type="text" class="form-control" id="orchestrationTagName"
               [formControl]="releaseCreateForm.controls.orchestrationTagName"
               [class.invalid-input]="releaseCreateForm.controls.orchestrationTagName.errors">
        @if (releaseCreateForm.controls.orchestrationTagName.errors?.['required']) {
          <div class="input-error">
            Tag Name is required
          </div>
        }
      </div>

      <div class="form-switch">
        <input class="form-check-input" type="checkbox" role="switch"
               [formControl]="releaseCreateForm.controls.isVisible">
        <label class="form-label">Visible</label>
      </div>

      <div class="buttons-container">
        <button type="submit" class="btn btn-success"
                [disabled]="releaseCreateForm.invalid || ongoingRequest">
          @if (ongoingRequest) {
            <i class="fa-solid fa-spinner rotating"></i>
          } @else {
            Save
          }
        </button>
      </div>
    </form>
  </div>
</main>
